

<div [formGroup]="parameterFormGroup">
  @if(parameter?.type === 'MULTI_SELECT') {
  <mat-form-field appearance="fill" class="fitWidth">
    <mat-label>{{'' | translate: ['dd.transport-option-parameter.'+parameter!.id+'.name',
      translationService.language]}}</mat-label>
    <input formControlName="multiSelect" matInput [required]="true" [disabled]="true">
    <sc-action-icon matSuffix (click)="showSelectionDialog()" iconClass="fa-plus"></sc-action-icon>
  </mat-form-field>
  }
  @if(parameter?.type === 'SINGLE_SELECT') {
  <sc-select-field labelDictionaryKey="dd.transport-option-parameter.{{parameter!.id}}.name" [data]="selectFieldOptions"
    formControlName="singleSelect"></sc-select-field>
  }
  @if(parameter?.type === 'TEXT') {
  <mat-form-field appearance="fill" class="fitWidth">
    <mat-label>{{'' | translate: ['dd.transport-option-parameter.'+parameter!.id+'.name',
      translationService.language]}}</mat-label>
    <input matInput formControlName="text" [required]="true">
  </mat-form-field>
  }
</div>
